export const RangeCalendarStyles = {
  dialogPaper: {
    width: '100%',
    maxWidth: 344,
    m: 2,
    borderRadius: 3,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    p: 2,
    backgroundColor: '#f7a707',
  },
  title: {
    mb: 1,
    color: 'common.white',
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.2,
  },
  headerSummaryRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
  },
  headerValue: {
    color: 'common.white',
    fontSize: 24,
    fontWeight: 400,
    lineHeight: 1.2,
    textTransform: 'lowercase',
  },
  headerIconButton: {
    mt: '2px',
    p: 0.5,
    color: 'common.white',
  },
  headerIcon: {
    fontSize: 18,
  },
  content: {
    p: '8px 12px 4px !important',
  },
  calendarWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  editMode: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr auto',
    gap: 1.5,
    alignItems: 'end',
    px: 0,
    pt: 1,
    pb: 1.5,
  },
  input: {
    '& .MuiInputBase-root': {
      fontSize: 16,
    },
    '& .MuiInputLabel-root': {
      fontSize: 12,
    },
  },
  modeSwitchButton: {
    width: 36,
    height: 36,
    mb: '4px',
    color: '#f7a707',
  },
  modeSwitchIcon: {
    fontSize: 20,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: 10,
    gap: 0.5,
    px: 1,
    pb: 1,
  },
};

export const DialogStyles = {
  '& .RangeCalendar-root': {
    width: '100%',
    position: 'relative',
  },
  '& .RangeCalendar-months': {
    display: 'flex',
    justifyContent: 'center',
  },
  '& .RangeCalendar-month': {
    width: '100%',
  },
  '& .RangeCalendar-monthCaption': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 32,
    mb: '4px',
    gap: '8px',
  },
  '& .RangeCalendar-monthCaptionLabel': {
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'capitalize',
  },
  '& .RangeCalendar-nav': {
    position: 'absolute',
    right: '0',
    top: '5px',
    display: 'flex',
    gap: 2,
  },
  '& .RangeCalendar-navButton': {
    width: 24,
    height: 24,
    border: 0,
    borderRadius: '50%',
    background: '#f5f5f5',
    color: '#616161',
    cursor: 'pointer',
    alignItems: 'center',
    display: 'flex',
    p: 0,
  },
  '& .RangeCalendar-navButton:hover': {
    background: 'rgba(0, 0, 0, 0.04)',
  },
  '& .RangeCalendar-chevron': {
    width: 24,
    height: 24,
  },
  '& .RangeCalendar-table': {
    width: '100%',
    borderCollapse: 'collapse',
  },
  '& .RangeCalendar-weekdays': {
    display: 'table-row',
  },
  '& .RangeCalendar-weekday': {
    color: '#9e9e9e',
    fontSize: 11,
    fontWeight: 500,
    textAlign: 'center',
    pb: '2px',
    textTransform: 'lowercase',
  },
  '& .RangeCalendar-weeks': {
    display: 'table-row-group',
  },
  '& .RangeCalendar-week': {
    display: 'table-row',
  },
  '& .RangeCalendar-day': {
    width: 36,
    height: 32,
    p: 0,
    textAlign: 'center',
    overflow: 'hidden',
  },
  '& .RangeCalendar-dayButton': {
    width: 32,
    height: 32,
    m: 0,
    border: 0,
    borderRadius: '16px',
    background: 'transparent',
    color: '#212121',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 400,
    position: 'relative',
    zIndex: 1,
  },
  '& .RangeCalendar-dayButton:hover': {
    background: '#f5f5f5',
  },
  '& .RangeCalendar-outside .RangeCalendar-dayButton': {
    color: '#d0d0d0',
  },
  '& .RangeCalendar-today .RangeCalendar-dayButton': {
    border: '1px solid #757575',
    borderRadius: '50% !important',
  },
  '& .RangeCalendar-selected .RangeCalendar-dayButton, & .RangeCalendar-rangeStart .RangeCalendar-dayButton, & .RangeCalendar-rangeEnd .RangeCalendar-dayButton':
    {
      background: '#f7a707',
      color: '#fff',
    },
  '& .RangeCalendar-rangeMiddle': {
    background: 'rgba(247, 167, 7, 0.6)',
  },
  '& .RangeCalendar-rangeMiddle .RangeCalendar-dayButton': {
    background: 'transparent',
    color: '#fff',
    borderRadius: 0,
  },
  '& .RangeCalendar-rangeStart': {
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    background: 'rgba(247, 167, 7, 0.6)',
  },
  '& .RangeCalendar-rangeEnd': {
    borderTopRightRadius: '16px',
    background: 'rgba(247, 167, 7, 0.6)',
    borderBottomRightRadius: '16px',
  },
};
